const isAdmin = (s) => {
    if (s=== "admin") {
        return true;
    } else {
        return false;
    }

}

export default isAdmin;